<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput :options="nameInput.options" :data="nameInput.data"/>
                </CCol>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                  <BaseSelect :options="typeSystemSelect.options" :data="typeSystemSelect.data"
                              ref="typeSystemSelect"></BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput :options="urlSendToStationInput.options" :data="urlSendToStationInput.data"/>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput :options="urlAddFileInput.options" :data="urlAddFileInput.data"/>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput :options="urlDeleteFileInput.options" :data="urlDeleteFileInput.data"/>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-save"></i> Lưu lại
                </CButton>
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"
                  ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../../base/BaseSelect2";
import BaseInput from "../../base/BaseInput";
import BaseLoading from "../../base/BaseFormLoading";
import BaseTextArea from "../../base/BaseTextArea.vue";

export default {
  name: "ContractorInformationUpdate",
  components: { BaseSelect, BaseInput, BaseLoading },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id",
        },
      },
      nameInput: {
        options: {
          label: "Tên đài truyền thanh <span class='required'>*</span>",
          placeholder: "Tên đài truyền thanh",
          maxlength: 35,
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên đài truyền thanh không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      urlSendToStationInput: {
        options: {
          label: "API gửi tới đài <span class='required'>*</span>",
          placeholder: "API gửi tới đài",
        },
        data: {
          name: "urlSendToStation",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.urlSendToStationInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "API gửi tới đài không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      urlAddFileInput: {
        options: {
          label: "API thêm mới bản tin <span class='required'>*</span>",
          placeholder: "API thêm mới bản tin",
        },
        data: {
          name: "urlAddFile",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.urlAddFileInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "API thêm mới bản tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      urlDeleteFileInput: {
        options: {
          label: "API xóa bản tin <span class='required'>*</span>",
          placeholder: "API xóa bản tin",
        },
        data: {
          name: "urlDeleteFile",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.urlDeleteFileInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "API xóa bản tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      typeSystemSelect: {
        options: {
          filter: false,
          label: "Hệ thống",
          'keyField': 'key',
          'valueField': 'value',
        },
        data: {
          name: "typeSystem",
          model: null,
          items: [
            {key: "0", value: "Truyền thanh cơ sở"},
            {key: "1", value: "Bản tin điện tử"}
          ],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.typeSystemSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Loại hệ thống không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      }
    };
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/contract_information/update",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Cập nhật cấu hình API thành công",
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    loadData: function () {
      let that = this;
      that.loading.value = true;
      this.$helper.loadDataSource({
        loading: that.loading,
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        ignoreDefaultData: true,
        url: "/contract_information/findById",
        successCallback: function (response) {
          that.$helper.setupDataResponse(that.$data, response.data.data);
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        },
      });
    },
  },
  computed: {
  },
  created() {
    this.loadData();
  },
  mounted() {
  },
  watch: {
  },
};
</script>
